module.exports = __webpack_public_path__ + "img/grieg_Kampen_mot_fascismen1.283c9820.jpg";